export default __webpack_public_path__ + "static/media/skype.83d08038.svg";